import { Inject, Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { HandleError, HttpErrorHandler } from '../form-services/error_handle.service';
import { catchError } from 'rxjs/operators';

import { BASE_URL } from '@services/utils';
import { environment } from 'src/environments/environment';

const login_options = {
  headers: new HttpHeaders({
    Accept: '*/*',
  }),
};

@Injectable({
  providedIn: 'root',
})
export class DataService {
  private base_url: string;
  private handleError: HandleError;

  constructor(
    private cookieService: CookieService,
    private _router: Router,
    private http: HttpClient,
    httpErrorHandler: HttpErrorHandler,
    @Inject(BASE_URL) baseUrl: string
  ) {
    this.handleError = httpErrorHandler.createHandleError('ServicesHandler');
    this.base_url = `${baseUrl}`;
    console.log(this.base_url);
  }

  http_options_comm(): HttpHeaders {
    return new HttpHeaders({
      Accept: '*/*',
      Authorization: 'Bearer ' + this.getCookie().access_token,
    });
  }

  http_no_auth(): HttpHeaders {
    return new HttpHeaders({
      Accept: '*/*',
    });
  }

  http_api_key(): HttpHeaders {
    return new HttpHeaders({
      Accept: '*/*',
      'X-API-KEY': environment.ceStagingApiKey,
    });
  }

  http_options_json(): HttpHeaders {
    return new HttpHeaders({
      Accept: '*/*',
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + this.getCookie().access_token,
    });
  }

  getCookie() {
    return {
      access_token: this.cookieService.get('access_token'),
      refresh_token: this.cookieService.get('refresh_token'),
    };
  }

  delCookie() {
    this.cookieService.deleteAll();
  }

  setCookie(access: string, refresh: string) {
    this.cookieService.set('access_token', access);
    this.cookieService.set('refresh_token', refresh);
  }

  setAccessToken(access: string) {
    this.cookieService.set('access_token', access);
  }

  logoutRedirect() {
    this.delCookie();
    this._router.navigate(['/'], { replaceUrl: true });
  }

  redirecttopage(a: string, b: boolean = false) {
    if (b) {
      this._router.navigate([a], { replaceUrl: true });
    } else {
      this._router.navigateByUrl(a);
    }
  }

  goto(page: string) {
    this._router.navigateByUrl(page);
  }

  islogined() {
    if (this.getCookie().access_token == '') {
      return false;
    } else {
      return true;
    }
  }

  login(a: any, b: string): Observable<any> {
    const fd: FormData = new FormData();
    for (const k in a) {
      const v = a[k];
      fd.append(k, v);
    }
    return this.http
      .post(this.base_url + b, fd, login_options)
      .pipe(catchError(this.handleError<any>('login_service', [])));
  }

  get(enpoint: string, query_string: any, headers = this.http_options_comm()) {
    const queryString = new HttpParams({ fromObject: query_string }).toString();
    enpoint = queryString.length > 1 ? enpoint + '?' + queryString : enpoint;
    return this.http
      .get(enpoint, {
        headers: headers,
      })
      .pipe(catchError(this.handleError<any>('get_main', [], {})));
  }

  text_get(a: any, b: string) {
    const queryString = new HttpParams({ fromObject: a }).toString();
    b = queryString.length > 1 ? b + '?' + queryString : b;
    return this.http
      .get(this.base_url + b, {
        headers: this.http_options_comm(),
        responseType: 'text' as 'json',
      })
      .pipe(catchError(this.handleError<any>('get_main', [], {})));
  }

  isArray(values: any) {
    return values instanceof Array;
  }

  post(endpoint: string, data: any, headers = this.http_options_comm()) {
    const form_data: FormData = new FormData();
    for (const data_key in data) {
      const data_value = data[data_key];
      form_data.append(data_key, data_value);
    }
    return this.http
      .post(endpoint, form_data, {
        headers: headers,
      })
      .pipe(catchError(this.handleError<any>('get_main', [], {})));
  }

  put(endpoint: any, data: any) {
    const form_data: FormData = new FormData();
    for (const data_key in data) {
      const data_value = data[data_key];
      form_data.append(data_key, data_value);
    }
    return this.http
      .put(endpoint, form_data, {
        headers: this.http_options_comm(),
      })
      .pipe(catchError(this.handleError<any>('get_main', [], {})));
  }

  putjson(a: any, b: string) {
    return this.http
      .put(this.base_url + b, a, {
        headers: this.http_options_json(),
      })
      .pipe(catchError(this.handleError<any>('get_main', [], {})));
  }

  postjson(endpoint: string, data: any, headers = this.http_options_comm()) {
    return this.http
      .post(endpoint, data, {
        headers: headers,
      })
      .pipe(catchError(this.handleError<any>('get_main', [], {})));
  }

  delete(a: any, b: string) {
    return this.http
      .delete(this.base_url + b, {
        headers: this.http_options_comm(),
        body: a,
      })
      .pipe(catchError(this.handleError<any>('get_main', [], {})));
  }

  fileandjson(url: any, formData: FormData) {
    return this.http
      .post(this.base_url + url, formData, {
        headers: this.http_options_comm(),
      })
      .pipe(catchError(this.handleError<any>('get_main', [], {})));
  }
}
